const COOKIE_POLICY_STORAGE = [
	{
		category: "Essential",
		purpose:
			"Used by our payment processor, Stripe, for fraud prevention and to keep payment sessions secure",
		names: "__stripe_mid, __stripe_sid",
		duration: "Up to 1 year",
		party: "Third-party",
	},
	{
		category: "Consent management",
		purpose:
			"Remembers the cookie choices you make via our Cookie Banner, so we don’t ask again on every visit",
		names: "cc_cookie",
		duration: "1 year",
		party: "First-party",
	},
] as const;

export const getDefaultCookiePolicyStorage = (_paymentsEnabled?: boolean) => [
	...COOKIE_POLICY_STORAGE,
];
